<app-header></app-header>

<div class="content-wrapper">
  <app-loader></app-loader>
  <app-alert></app-alert>
  <router-outlet></router-outlet>
</div>
